import { useMemo, useState } from 'react';
import type { ApiEndpoints } from '@avisoma/shared';
import { Card } from '../../components/Card';
import { DescriptionList, DescriptionTerm, DescriptionDetails } from '../../catalyst/description-list';
import { ThrustConversionTable } from '../../components/reconstructedDocument/extractionTables/ThrustConversionTable';
import { ExtractionTableCard } from '../../components/reconstructedDocument/extractionTables/ExtractionTableCard';
import { RowInspectorDialog } from '../../components/reconstructedDocument/extractionTables/RowInspectorDialog';

interface ThrustConversionEventsProps {
  response: ApiEndpoints<string>['/api/projects/:id']['GET']['response'];
}

export function ThrustConversionEvents({ response }: ThrustConversionEventsProps) {
  const data = response.item.data?.thrustConversionEvents;
  const rows = data?.thrustConversionEvents;
  const [inspected, setInspected] = useState<unknown>(null);

  // Project thrust rows carry `pageId` only — no document page order — so the
  // Page column links without inventing a position number.
  const pageIdToPosition = useMemo(() => new Map<string, number>(), []);

  if (!data || !rows) {
    return null;
  }

  return (
    <div className="space-y-6">
      <Card
        header={
          <h2 className="text-lg font-medium text-gray-900 dark:text-zinc-100">
            Thrust Rating Change Records
          </h2>
        }
      >
        <DescriptionList>
          {data.esn && (
            <>
              <DescriptionTerm>ESN</DescriptionTerm>
              <DescriptionDetails className="font-mono">{data.esn}</DescriptionDetails>
            </>
          )}
          <DescriptionTerm>Conversion Count</DescriptionTerm>
          <DescriptionDetails>{rows.length}</DescriptionDetails>
        </DescriptionList>
      </Card>

      <ExtractionTableCard
        label="Thrust Rating Change Records"
        rows={rows}
        csvTitle="Thrust Conversion Events"
        bodyHeight="project"
      >
        <ThrustConversionTable rows={rows} pageIdToPosition={pageIdToPosition} onInspect={setInspected} />
      </ExtractionTableCard>

      <RowInspectorDialog
        open={inspected != null}
        onClose={() => setInspected(null)}
        title="Thrust Conversion row"
        data={inspected}
      />
    </div>
  );
}
